export default __webpack_public_path__ + "static/media/poke-items.0528da12.jpg";